/** Stored on `publicLeadSubmissions` for `kind: contact`; must match API allowlist. */
export const CONTACT_REASON_OPTIONS = [
  { value: 'general', label: 'General question' },
  { value: 'demo', label: 'Demo or pilot' },
  { value: 'bug', label: "Something isn't working" },
  { value: 'feature', label: 'Feature or improvement idea' },
  { value: 'other', label: 'Other' },
] as const;

export type ContactReason = (typeof CONTACT_REASON_OPTIONS)[number]['value'];
